<template lang="html">
<div class="v-scope-error-404">
<section class="error-404">
    <h1 style="margin-top: 200px">Error de conexión, por favor revisa tu conexión</h1>
  </section>
</div>
</template>

<script lang="js">
  export default  {
    name: 'error-404',
}
</script>



// WEBPACK FOOTER //
// src/components/views/error-404.vue